// extracted by mini-css-extract-plugin
export default {"restrictedText":"style_restrictedText__s0WNm","professionSelectSection":"style_professionSelectSection__3ygah"};